import {EntityApiService} from '@dofleini/security';

class CommercialRegisterApiService extends EntityApiService {


}

export default new CommercialRegisterApiService('/ms-auth/api/commercial-registers');
